//Custom View 
(function ($, undefined) {
    var kendo = window.kendo,
        ui = kendo.ui,
        SchedulerView = ui.SchedulerView,
        extend = $.extend,
        NS = ".kendoMonthCustomView",
        DATA_HEADER_TEMPLATE = kendo.template("<span class='k-link k-nav-day'>#=kendo.toString(date, 'dd')#</span>"),
        EVENT_TEMPLATE = '<div class="k-task"' +
            'title="#:title.replace(/"/g,"\'")#" ' +
            'data-#=kendo.ns#uid="#=uid#"' +
            '#if (resources[0]) { #' +
            'style="color:#=resources[0].color#;"' +
            '#}#>' +
            "# if (data.isException()) { #" +
            '<span class="k-icon k-i-exception"></span>' +
            '# } else if (data.isRecurring()) {#' +
            '<span class="k-icon k-i-refresh"></span>' +
            "# } #" +
            '#:title#' +
            '#if (showDelete) {#' +
            '<a href="\\#" class="k-link k-task-delete"><span class="k-icon k-si-close"></span></a>' +
            '#}#' +
            '</div>';

    function getWorkDays(options) {
        var workDays = [];
        var dayIndex = options.workWeekStart;

        workDays.push(dayIndex);

        while (options.workWeekEnd !== dayIndex) {
            if (dayIndex > 6) {
                dayIndex -= 7;
            } else {
                dayIndex++;
            }
            workDays.push(dayIndex);
        }
        return workDays;
    }

    var counter = 0;

    var MonthCustomView = SchedulerView.extend({
        init: function (element, options) {
            var that = this;

            SchedulerView.fn.init.call(that, element, options);

            that.title = that.options.title || that.options.name;

            //get workDays to color them
            that._workDays = getWorkDays(that.options);

            that._templates();

            that._editable();

            //render base layout of the view
            that._renderLayout();
            element.find('.k-scheduler-layout').wrap('<div class="custom-view-table-wrapper table-responsive"></div>');
        },

        name: "customMonth",

        options: {
            title: "CustomMonth",
            selectedDateFormat: "{0:D} - {1:D}",
            dateHeaderTemplate: DATA_HEADER_TEMPLATE,
            eventTemplate: EVENT_TEMPLATE
        },

        //Declaring methods to avoid errors. May be implemented if needed in the future.
        _selectEvents: function () {

        },
        _selectSlots: function (selection) {

        },
        constrainSelection: function (selection) {
        },
        //

        _editable: function () {
            var that = this;

            that.element.on("click" + NS, ".k-task a:has(.k-si-close)", function (e) {
                that.trigger("remove", { uid: $(this).closest(".k-task").attr(kendo.attr("uid")) });
                e.preventDefault();
            });

            if (that.options.editable.update !== false) {
                that.element.on("dblclick" + NS, ".k-scheduler-content td", function (e) {
                    var cell = $(this);
                    if (cell.children().length) {
                        that.trigger("edit", { uid: cell.find(".k-task").attr(kendo.attr("uid")) });
                        e.preventDefault();
                    }
                });
            }

            if (that.options.editable.create !== false) {
                that.element.on("dblclick" + NS, ".k-scheduler-content td", function (e) {
                    var cell = $(this);
                    if (!cell.children().length) {
                        var dayIndex = cell.index();
                        var startDate = kendo.date.addDays(that.startDate(), dayIndex);
                        var endDate = new Date(startDate.getTime() + (60 * 60 * 1000));
                        that.trigger("add", { eventInfo: { title: "No Title", start: startDate, end: endDate } });
                        e.preventDefault();
                    }
                });
            }
        },

        _templates: function () {
            var options = this.options;
            var settings = extend({}, kendo.Template, options.templateSettings);

            this.dateHeaderTemplate = kendo.template(options.dateHeaderTemplate, settings);
            this._eventTemplate = kendo.template(options.eventTemplate);
        },

        startDate: function () {
            return this._startDate;
        },

        endDate: function () {
            return this._endDate;
        },

        nextDate: function () {
            var startDate = this.startDate();
            return new Date(startDate.getFullYear(), startDate.getMonth() + 1, 1);
        },

        previousDate: function () {
            var startDate = this.startDate();
            return new Date(startDate.getFullYear(), startDate.getMonth() - 1, 1);
        },

        date: function (value) {
            this.options.date = value;
        },

        calculateDateRange: function () {
            var selectedDate = this.options.date;
            var start;
            if (selectedDate.toDateString() == new Date().toDateString()) {
                start = kendo.date.firstDayOfMonth(new Date());
            }
            else {
                start = kendo.date.firstDayOfMonth(selectedDate);
            }
            var dayInMonth = this._getDaysInMonth(start.getFullYear(), start.getMonth());
            var idx;
            var length;
            var dates = [];
            dates.push(start);
            for (idx = 1, length = dayInMonth; idx < length; idx++) {
                start = kendo.date.nextDay(start);
                dates.push(start);
            }

            return dates;
        },

        _getDaysInMonth: function (year, month) {
            return new Date(year, month + 1, 0).getDate();
        },

        _renderLayout: function () {
            var dates = this.calculateDateRange();

            dates = dates || [];

            this._dates = dates;
            this._startDate = dates[0];
            this._endDate = dates[(dates.length - 1) || 0];

            this.createLayout(this._layout(dates));
        },

        _layout: function (dates) {
            var that = this;
            var columns = [];
            var options = that.options;

            for (var idx = 0; idx < dates.length; idx++) {
                var column = {};

                column.text = that.dateHeaderTemplate({
                    date: dates[idx]
                });

                if (kendo.date.isToday(dates[idx])) {
                    column.className = "k-today";
                }

                columns.push(column);
            }

            return {
                columns: columns,
                rows: []
            };
        },

        render: function (events) {
            var that = this;
            var table = that.content.find("table").empty();
            var groupsByDay = [];

            if (events.length > 0) {
                

                //group resources by day
                groupsByDay = that._tasks(events);
                var $taskline = $('<tr><td class="border-0 p-0"></td></tr>');
                $taskline.find('td').append(that._renderTasks(groupsByDay, []));
                table.append($taskline);

                // render long events
                groupsByDay = that._longTasks(events);
                var $longTaskline = $('<tr><td class="border-0 p-0"></td></tr>');
                $longTaskline.find('td').append(that._renderLongTasks(groupsByDay, []));
                table.append($longTaskline);
            } else {
                var tableContent = '';
                for (var dateIndex = 0; dateIndex < that._dates.length; dateIndex++) {
                    var isToday = kendo.date.isToday(that._dates[dateIndex]);
                    tableContent += '<td ' + (isToday ? 'class="k-today"' : '') + '></td>';
                }
                table.append('<tr>' + tableContent + '</tr>');
            }

            var $lines = table.filter('.k-scheduler-table').children();
            $lines.each(function () {
                var $this = $(this);
                if ($.trim($this.text()) === '') {
                    $this.addClass('no-items');
                }
            });

            that.refreshLayout();
            that.trigger("activate");
        },

        //get needed tasks from dataSource
        _tasks: function (events) {
            var tasks = [];

            for (var idx = 0; idx < events.length; idx++) {
                var event = events[idx];
                var start = event.start;
                var end = event.end;

                if (event.isAllDay) {
                    end = kendo.date.nextDay(end);
                }

                var eventDurationInDays = Math.ceil((end - start) / kendo.date.MS_PER_DAY);

                if (!event.isAllDay && eventDurationInDays === 1 && kendo.date.getDate(end).getTime() !== kendo.date.getDate(start).getTime()) {
                    eventDurationInDays += 1;
                }

                var task = event.clone();
                task.startDate = kendo.date.getDate(start);

                if (task.startDate >= this.startDate()) {
                    if (start.getFullYear() === end.getFullYear() && start.getMonth() === end.getMonth() && start.getDate() === end.getDate()) {
                        tasks.push(task);
                    }
                }

            }

            return new kendo.data.Query(tasks).sort([{
                field: "start",
                dir: "asc"
            }, {
                field: "end",
                dir: "asc"
            }]).groupBy({
                field: "startDate"
            }).toArray();
        },

        _longTasks: function (events) {
            var tasks = [];

            for (var idx = 0; idx < events.length; idx++) {
                var event = events[idx];
                var start = event.start;
                var end = event.end;

                if (event.isAllDay) {
                    end = kendo.date.nextDay(end);
                }

                var eventDurationInDays = Math.ceil((end - start) / kendo.date.MS_PER_DAY);

                if (!event.isAllDay && eventDurationInDays === 1 && kendo.date.getDate(end).getTime() !== kendo.date.getDate(start).getTime()) {
                    eventDurationInDays += 1;
                }

                var task = event.clone();
                task.startDate = kendo.date.getDate(start);

                if (start.getFullYear() !== end.getFullYear() || start.getMonth() !== end.getMonth() || start.getDate() !== end.getDate()) {
                    tasks.push(task);
                }

            }

            return tasks;
        },


        _getItemsByMonthYearAndDay: function (month, year, day, tasksGroupsByDay) {
            var result = [];

            for (var groupIndex = 0; groupIndex < tasksGroupsByDay.length; groupIndex++) {
                var currentGroup = tasksGroupsByDay[groupIndex];
                for (var itemIndex = 0; itemIndex < currentGroup.items.length; itemIndex++) {
                    var currentMonth = currentGroup.items[itemIndex].startDate.getMonth();
                    var currentYear = currentGroup.items[itemIndex].startDate.getYear();
                    var currentDay = currentGroup.items[itemIndex].startDate.getDate();
                    if (currentMonth === month && currentYear === year && currentDay === day) {
                        result.push(currentGroup.items[itemIndex])
                    }
                }
            }

            return result;
        },

        _renderTasks: function (tasksGroupsByDay, groups) {
            var that = this;
            var tableRows = [];
            var dateGroupMapping = {};
            var maxRowCount = 0;
            var groupIndex = 0;

            maxRowCount = this._getMaxGroupCount(tasksGroupsByDay);

            var tbl = document.createElement('table');
            tbl.setAttribute('class', 'calendar-table');
            var tbdy = document.createElement('tbody');
            for (var rowIndex = 0; rowIndex < maxRowCount; rowIndex++) {
                var tr = document.createElement('tr');
                for (var dateIndex = 0; dateIndex < that._dates.length; dateIndex++) {
                    var currentDate = that._dates[dateIndex];
                    var isToday = kendo.date.isToday(currentDate);
                    var currentMonth = currentDate.getMonth();
                    var currentYear = currentDate.getYear();
                    var currentDay = currentDate.getDate();
                    var currentDates = that._getItemsByMonthYearAndDay(currentMonth, currentYear, currentDay, tasksGroupsByDay);
                    var task = currentDates[rowIndex];
                    var htmlElement = this._generateCellContent(task, isToday);


                    tr.appendChild(htmlElement);
                }
                tbdy.appendChild(tr);
            }
            tbl.appendChild(tbdy);
            return tbl;
        },

        _renderLongTasks: function (tasksGroupsByDay, groups) {
            var that = this;
            var tableRows = [];
            var dateGroupMapping = {};
            var maxRowCount = 0;
            var groupIndex = 0;

            var tbl = document.createElement('table');
            tbl.setAttribute('class', 'calendar-table');
            var tbdy = document.createElement('tbody');

            for (var rowIndex = 0; rowIndex < tasksGroupsByDay.length; rowIndex++) {
                var event = tasksGroupsByDay[rowIndex];
                var startDay, endDay;
                var currentYear = that._dates[0].getYear();
                var currentMonth = that._dates[0].getMonth();
                var eventStartMonth = event.start.getMonth();
                var eventEndMonth = event.end.getMonth();
                var eventStartYear = event.start.getYear();
                var eventEndYear = event.end.getYear();

                if (eventStartMonth == eventEndMonth && eventStartYear == eventEndYear) {
                    startDay = event.start.getDate();
                    endDay = event.end.getDate();
                }
                else if (eventStartMonth != eventEndMonth || eventStartYear != eventEndYear) {
                    if (eventStartMonth < currentMonth && eventStartYear == currentYear) {
                        startDay = 1;
                    }
                    else if (eventStartMonth < currentMonth && eventStartYear < currentYear) {
                        startDay = 1;
                    }
                    else if (eventStartMonth == currentMonth && eventStartYear == currentYear) {
                        startDay = event.start.getDate();
                    }

                    if (eventEndMonth > currentMonth && eventEndYear == currentYear) {
                        endDay = this._getDaysInMonth(eventEndYear, currentMonth);
                    }
                    else if (eventEndMonth > currentMonth && eventEndYear > currentYear) {
                        endDay = this._getDaysInMonth(currentYear, currentMonth);
                    }
                    else if (eventEndMonth = currentMonth && eventEndYear == currentYear) {
                        endDay = event.end.getDate();
                    }
                }
                
                var eventDuration = 1;
                if ((endDay - startDay) > 0) eventDuration = endDay - startDay + 1;
                var tr = document.createElement('tr');
                for (var dateIndex = 0; dateIndex < that._dates.length; dateIndex++) {
                    var currentDate = that._dates[dateIndex];
                    var isToday = kendo.date.isToday(currentDate);
                    var currentDay = currentDate.getDate();
                    if (currentDay >= startDay && currentDay <= endDay && event.IsRendered == undefined) {
                        var htmlElement = this._generateCellContent(event, isToday, eventDuration);
                        tr.appendChild(htmlElement);
                        event.IsRendered = true;
                    }
                    else {
                        var htmlElement = this._generateCellContent(undefined, isToday);
                        tr.appendChild(htmlElement);
                    }
                }

                tbdy.appendChild(tr);
            }

            tbl.appendChild(tbdy);
            return tbl;
        },

        _generateCellContent: function (task, isToday, duration) {
            if (task) {
                var resources = this.eventResources(task),
                    editable = this.options.editable;

                //build data needed by template
                var templateData = extend({}, {
                    ns: kendo.ns,
                    resources: resources,
                    showDelete: editable && editable.destroy !== false
                }, task)

                var template = this._eventTemplate(templateData);

                var td = document.createElement('td');

                var $header = $('.k-scheduler-header-wrap');
                var width = $header.find("th");
                var padding = 10;

                if (duration != undefined) {
                    
                    width = width[0].clientWidth * duration - padding;
                    template = '<div ' +
                        (isToday ? 'class="k-event"' : '') + ' style="overflow: hidden; width: ' + width + 'px;" class="k-event" data-uid="' + task.uid + '">' + template + '</div>';
                }
                else {
                    width = width[0].clientWidth - padding;
                    template = '<div ' +
                        (isToday ? 'class="k-event"' : '') + ' style="overflow: hidden; width: ' + width + 'px;" class="k-event" data-uid="' + task.uid + '">' + 
                        ' <div class="k-event-block" style="background-color: ' + task.color + ';"><div class="template-wrapper"><h6 class="btn-primary-ref">....</h6></div></div >'
                        + '</div>';
                }
                
                td.innerHTML = template
                return td;

            } else {
                return document.createElement('td');
            }
        },

        _getMaxGroupCount: function (group) {
            var that = this;
            var maxCount = 0;

            for (var groupIndex = 0; groupIndex < group.length; groupIndex++) {
                var date = group[groupIndex].value;
                var month = date.getMonth();
                var year = date.getYear();
                var day = date.getDate();
                var groupLength = that._getItemsByMonthYearAndDay(month, year, day, group).length;
                if (groupLength > maxCount) {
                    maxCount = groupLength;
                }
            }

            return maxCount;
        },

        //detach events
        destroy: function () {
            if (this.element) {
                this.element.off(NS);
            }
            ui.SchedulerView.fn.destroy.call(this);
        }
    })

    //extend UI
    extend(true, ui, {
        MonthCustomView: MonthCustomView
    });

})(window.kendo.jQuery);